document.addEventListener('DOMContentLoaded', function() {
    let slider = tns({
        container: `.slider-articles`,
        items: 1,
        slideBy: 1,
        autoplay: false,
        controlsContainer: `.blog-container-arrow`,
        loop: true,
        nav: true,
        autoHeight: true,
        mouseDrag: true,
        navPosition: 'bottom',
        responsive: {
            1024: {
                controlsContainer: false,
                autoHeight: false,
            }
          },
    });

    // detectar si el viewport es menor a 1024px y hacer slider la clase .container-articles
    let viewport = window.matchMedia('(max-width: 1024px)');

    if (viewport.matches) {
        let sliderArticle = tns({
            container: `.container-articles`,
            items: 1.0495,
            slideBy: 1,
            autoplay: false,
            controlsContainer: `.blog-container-arrow`,
            loop: true,
            nav: true,
            mouseDrag: true,
            navPosition: 'bottom',
        });
    }


    /* let sliderArticle = tns({
        container: `.container-articles`,
        items: 1,
        slideBy: 1,
        autoplay: false,
        controlsContainer: `.container-arrow`,
        loop: true,
        nav: true,
        autoHeight: true,
        mouseDrag: true,
        navPosition: 'bottom',
        responsive: {
            1024: {
                controlsContainer: false,
                autoHeight: false,
            }
          },
    }); */
});